import { put, call } from "redux-saga/effects";
import { AUTH_TOKEN, REFRESH_TOKEN, USER_NAME, USER_ID } from "../../../constants/servicio-autenticacion/Auth";
import { authSaga, authMicrosoftSaga } from "axios/servicio-autenticacion/Auth";
import authActions from '../../../actions/servicio-autenticacion/Auth'


// Se realiza peticiones a la api para la autenticación
function* signInApi({ payload }) {
    try {
      const user = yield call(authSaga, payload);
      if (user.msg) {
        yield put( authActions.showAuthMessageAction(user.msg) );
      } else if (!user?.token || !user?.uid) {
        yield put( authActions.showAuthMessageAction('Correo o contraseña incorrectos') );
      } else {
        const username = `${user.nombres || ''} ${user.apellidos || ''}`.trim();
        localStorage.setItem(AUTH_TOKEN, user.token);
        if (user.refreshToken) {
          localStorage.setItem(REFRESH_TOKEN, user.refreshToken);
        }
        localStorage.setItem(USER_ID, user.uid);
        localStorage.setItem(USER_NAME, username);
        yield put( authActions.authenticatedAction(user) );
      }
    } catch (err) {
      yield put( authActions.showAuthMessageAction(err.message) ); 
    }
}

function* signInMicrosoft({ payload }) {
    try {
      const user = yield call(authMicrosoftSaga, payload);
      if (user.msg) {
        yield put(authActions.showAuthMessageAction(user.msg));
      } else if (!user?.token || !user?.uid) {
        yield put(authActions.showAuthMessageAction('No fue posible iniciar sesión con Microsoft'));
      } else {
        const username = `${user.nombres || ''} ${user.apellidos || ''}`.trim();
        localStorage.setItem(AUTH_TOKEN, user.token);
        if (user.refreshToken) {
          localStorage.setItem(REFRESH_TOKEN, user.refreshToken);
        }
        localStorage.setItem(USER_ID, user.uid);
        localStorage.setItem(USER_NAME, username || user.correo || user.username || '');
        if (user.correo) {
          localStorage.setItem('AUTH_EMAIL', user.correo);
        }
        yield put(authActions.authenticatedAction(user));
      }
    } catch (err) {
      yield put(authActions.showAuthMessageAction(err.message));
    }
}

// Se realiza peticiones a la api para el deslogueo
function* signOut() {
    try {
        localStorage.removeItem(AUTH_TOKEN);
        localStorage.removeItem(REFRESH_TOKEN);
        localStorage.removeItem(USER_NAME);
        localStorage.removeItem(USER_ID);
        localStorage.removeItem('persist:viewer')
        localStorage.removeItem('persist:root')
        yield put( authActions.signOutSuccessAction() );
     
    } catch (err) {
        yield put( authActions.showAuthMessageAction(err) );
    }
}

export default { signInApi, signInMicrosoft, signOut }
